import create from 'zustand/vanilla';
import createHook from 'zustand';
import { emptyObject } from '@constants/empty';

const sortByDateFn = (a, b) => {
  const aDate = new Date(a);
  const bDate = new Date(b);
  return aDate > bDate ? 1 : -1;
};

export const infoStore = create((set) => ({
  plannerInfo: emptyObject,
  setPlannerInfo: (plannerData, goalUID) => {
    set((state) => {
      const stateData = state.plannerInfo?.[goalUID] || emptyObject;
      const plannerItemsByDays = stateData.plannerItemsByDays || emptyObject;
      const allDateKeys = Object.keys(
        plannerData?.plannerItemsByDays || emptyObject
      );
      let itemUpdateInfo = { ...stateData.itemUpdateInfo };
      if (allDateKeys.length > 0) {
        const updatedAt = Date.now();
        const updateDatekey = allDateKeys.sort(sortByDateFn)[0];
        itemUpdateInfo = { updatedAt, updateDatekey };
      }

      return {
        ...state,
        plannerInfo: {
          ...state.plannerInfo,
          [goalUID]: {
            ...stateData,
            ...plannerData,
            itemUpdateInfo,
            plannerItemsByDays: {
              ...plannerItemsByDays,
              ...(plannerData.plannerItemsByDays || emptyObject)
            }
          }
        }
      };
    });
  }
}));

export const infoStoreV2 = create((set) => ({
  plannerInfo: emptyObject,
  setPlannerInfo: (plannerData) => {
    set((state) => {
      const statePlannerItemsByDays = state?.plannerInfo?.plannerItemsByDays;
      const stateDateAndKeys = state?.plannerInfo?.datesAndKeys;
      return {
        ...state,
        plannerInfo: {
          ...state.plannerInfo,
          datesAndKeys: plannerData.datesAndKeys || stateDateAndKeys || [],
          plannerItemsByDays:
            plannerData.plannerItemsByDays || statePlannerItemsByDays || []
        }
      };
    });
  }
}));

const useInfoStore = createHook(infoStore);
export const useInfoStoreV2 = createHook(infoStoreV2);

export default useInfoStore;
